class DitecFormAccordion
{
    constructor()
    {
        const form = document.querySelector('.frame-type-form_formframework');
        if (!form) return;

        const formGroups = form.querySelectorAll('div.form-group');
        if (!formGroups) return;

        const fieldsets = form.querySelectorAll('fieldset');
        if (!fieldsets) return;

        this.init(form, formGroups, fieldsets);
    }

    init(form, formGroups, fieldsets)
    {
        for (const formGroup of formGroups) {
            const input = formGroup.querySelector('input, select, textarea');
            if (null === input) continue;
            const name = input.getAttribute('name');
            const identifier = name.split('[')[name.split('[').length - 1].split(']')[0];
            if ('hidden' === input.getAttribute('type')) {
                formGroup.classList.add(`form-group--checkbox`);
            }
            else {
                formGroup.classList.add(`form-group--${input.tagName.toLowerCase()}`);
            }
            formGroup.id = identifier;
        }

        for (const fieldset of fieldsets) {
            const legend = fieldset.querySelector('legend');
            legend.addEventListener('click', () => {
                fieldset.classList.toggle('-expanded');
            });
        }

        fieldsets[0]?.classList.add('-expanded');
    }
}

export default DitecFormAccordion;